export enum EnumTier {
  BETWEEN_1_TO_4 = "1_a_4_colaboradores",
  BETWEEN_5_TO_9 = "5_a_9_colaboradores",
  BETWEEN_10_TO_49 = "10_a_49_colaboradores",
  BETWEEN_50_TO_99 = "50_a_99_colaboradores",
  BETWEEN_100_TO_499 = "100_a_499_colaboradores",
  BETWEEN_500_TO_1999 = "500_a_1999_colaboradores",
  MORE_THAN_2000 = "+2000_colaboradores",
}
